import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconUI from "./ui/icon_ui";
import HomeIcon from "@mui/icons-material/Home";
import MUIDataTable from "mui-datatables";
import Modal from "@mui/material/Modal";
// iconos
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import InfoIcon from "@mui/icons-material/Info";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import EventIcon from "@mui/icons-material/Event";
import MessageIcon from "@mui/icons-material/Message";
import CancelIcon from "@mui/icons-material/Cancel";
import { services } from "../services/api";
import GifLoader from "./ui/gifLoader";
import dayjs from "dayjs";
import { Button, Stack, TextField } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonIcon from "@mui/icons-material/Person";
import CategoryIcon from "@mui/icons-material/Category";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import KeyIcon from "@mui/icons-material/Key";
import PasswordIcon from "@mui/icons-material/Password";
import LockIcon from "@mui/icons-material/Lock";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import LaunchIcon from "@mui/icons-material/Launch";
import SearchBar from "./SearchBar";
import { downloadCSVFromString } from "../utils/donwloadCSVFromString";

const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

const Bitacora = () => {
    const [isLoading, setLoading] = useState(false);

    let date = new Date();
    let ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const [filtros, setFiltros] = useState({
        fechaI: dayjs().format("YYYY-MM-01"),
        fechaF: dayjs().format(`YYYY-MM-${ultimoDia.getDate()}`),
    });

    const handleFiltros = ({ target }) => {
        const { name, value } = target;
        setFiltros({ ...filtros, [name]: value });
    };

    const options = {
        selectableRows: "none",
        tableBodyHeight: "auto",
        // Metodo para descargar CSV con utf-8 para los caracteres especiales
        onDownload: (buildHead, buildBody, columns, data) => {
            return "\uFEFF" + buildHead(columns) + buildBody(data);
        },
        textLabels: {
            body: {
                // noMatch: isLoading ? <Loader /> : "Lo sentimos, no hay coincidencias en la busqueda",
                noMatch: "Lo sentimos, no hay coincidencias en la busqueda",
                toolTip: "Clasificar",
                columnHeaderTooltip: (column) => `Clasificar por ${column.label}`,
            },
            pagination: {
                next: "Siguiente",
                previous: "Anterior",
                rowsPerPage: "Filas por página:",
                displayRows: "de",
            },
            toolbar: {
                search: "Buscar",
                downloadCsv: "Descargar CSV",
                print: "Imprimir",
                viewColumns: "Ver columnas",
                filterTable: "Filtrar tabla",
            },
            filter: {
                all: "Todo",
                title: "Filtros",
                reset: "Restaurar",
            },
            viewColumns: {
                title: "Ver columnas",
                titleAria: "Mostrar/Ocultar columnas en la tabla",
            },
            selectedRows: {
                text: "columna(s) selecciona(as)",
                delete: "Eliminar",
                deleteAria: "Eliminar filas seleccionadas",
            },
        },
        responsive: "standard",
        download: false,
        print: false,
        filter: false,
        viewColumns: false,

        downloadOptions: {
            filename: "Bitacora.csv",
            filterOptions: {
                useDisplayedColumnsOnly: true,
                useDisplayedRowsOnly: true,
            },
            utf8WithBom: true,
        },
        pagination: false
    };

    const [state, setState] = useState({
        estatus: 0,
        buscar: "Curp, linea de captura, importe, etc.",
        year: 0,
        yeardate: "",
        periodo: "",
        showmodal: false,
        dataApiBitacora: [],
    });

    const [stateModal, setStateModal] = useState({
        importModal: "",
        usuarioCanje: "",
        categoria: "",
        claveDependencia: "",
        claveOficina: "",
        ConceptoModal: "",
        EstatusModal: "",
        FcanjeModal: "",
        fechaGeneracion: "",
        FpagoModal: "",
        FvencimientoModal: "",
        formato: "",
        idLinea: "",
        LineaCapturaModal: "",
        nombreDependencia: "",
        usuarioCaptura: "",
    });

    const [meta, setMeta] = useState({ current_page: 1, last_page: 1 });
    const [data, setData] = useState([]);
    const [search, setSearch] = useState(null);

    useEffect(() => {
        getBitacora().then();
    }, []);

    const getBitacora = async (searchValue = search, flagDownload = false, cursor=null) => {
        setLoading(true);
        let urlAux = "bitacora/listar"
        if(cursor){
            urlAux = `bitacora/listar?cursor=${cursor}`
        }
        const body = {
            fechaInicio: filtros.fechaI,
            fechaFin: filtros.fechaF,
            q: searchValue,
            descargar: flagDownload ? 1 : 0
        };

        try {
            const res = await services("POST", urlAux, body);

            if (flagDownload) {
                downloadCSVFromString(res.data, "bitácora.csv");
            } else {
                const finalData = res.data.data.map((registro) => ({
                    ...registro,
                    lcaptura: `'${registro.lcaptura}`,
                    reciboSap: registro.reciboSap ? `'${registro.reciboSap}` : null,
                }));

                setData(finalData);
                setMeta(res.data.meta);
            }
        } catch (err) {
            console.error("Error cargando bitácora:", err);
        } finally {
            setLoading(false);
        }
    };

    const colorletras = "#6f1d46";

    const openModal = (value) => {
        setState({ ...state, showmodal: true });

        setStateModal({
            ...stateModal,
            importModal: value.Importe === null ? "N/A" : value.Importe,
            usuarioCanje: value.UsuarioCanje === null ? "N/A" : value.UsuarioCanje,
            categoria: value.categoria === null ? "N/A" : value.categoria,
            claveDependencia:
                value.claveDependencia === null ? "N/A" : value.claveDependencia,
            claveOficina: value.claveOficina === null ? "N/A" : value.claveOficina,
            ConceptoModal: value.concepto === null ? "N/A" : value.concepto,
            EstatusModal: value.estatus === null ? "N/A" : value.estatus,
            FcanjeModal: value.fechaCanje === null ? "N/A" : value.fechaCanje,
            fechaGeneracion:
                value.fechaGeneracion === null ? "N/A" : value.fechaGeneracion,
            FpagoModal: value.fechaPago === null ? "N/A" : value.fechaPago,
            FvencimientoModal:
                value.fechaVencimiento === null ? "N/A" : value.fechaVencimiento,
            formato: value.formato,
            idLinea: value.id === null ? "N/A" : value.id,
            LineaCapturaModal: value.lcaptura === null ? "N/A" : value.lcaptura,
            nombreDependencia:
                value.nombreDependencia === null ? "N/A" : value.nombreDependencia,
            usuarioCaptura:
                value.usuarioCaptura === null ? "N/A" : value.usuarioCaptura,
        });
    };
    const closeModal = () => {
        setState({ ...state, showmodal: false });
    };

    const columns = [
        // ESTATUS
        {
            name: "estatus",
            label: "Estatus",
            align: "center",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, i) => {
                    let estatus = data[dataIndex].estatus;
                    return (
                        <div
                            style={{
                                height: "100px",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {estatus}
                        </div>
                    );
                },
            },
        },
        // LINEA DE CAPTURA
        {
            name: "lcaptura",
            label: "Línea de captura",
            align: "center",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, i) => {
                    let Lineadecaptura = data[dataIndex].lcaptura;
                    return (
                        <div
                            style={{
                                height: "100px",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-3 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {Lineadecaptura.substring(1)}
                        </div>
                    );
                },
            },
        },
        // IMPORTE
        {
            name: "Importe",
            label: "Importe",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, i) => {
                    let importe = data[dataIndex].Importe;
                    return (
                        <div
                            style={{
                                height: "100px",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={
                                i % 2 === 0
                                    ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                    : "d-flex align-items-center justify-content-center"
                            }
                        >
                            $ {importe}
                        </div>
                    );
                },
            },
        },
        // CONCEPTO
        {
            name: "concepto",
            label: "Concepto",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let Concepto = data[dataIndex].concepto;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {Concepto}
                        </div>
                    );
                },
            },
        },
        // USUARIO CANJE
        {
            name: "UsuarioCanje",
            label: "Usuario Canje",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,

                customBodyRenderLite: (dataIndex, i) => {
                    let usuarioCanje = data[dataIndex].UsuarioCanje;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {usuarioCanje === null ? "N/A" : usuarioCanje}
                        </div>
                    );
                },
            },
        },
        // CATEGORIA
        {
            name: "categoria",
            label: "Categoría",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let categoria = data[dataIndex].categoria;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {categoria === null ? "N/A" : categoria}
                        </div>
                    );
                },
            },
        },
        // CLAVE DEPENDENCIA
        {
            name: "claveDependencia",
            label: "Clave dependencia",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let claveDependencia =
                        data[dataIndex].claveDependencia;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {claveDependencia === null ? "N/A" : claveDependencia}
                        </div>
                    );
                },
            },
        },
        // CLAVE OFICINA
        {
            name: "claveOficina",
            label: "Clave oficina",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let claveOficina = data[dataIndex].claveOficina;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {claveOficina === null ? "N/A" : claveOficina}
                        </div>
                    );
                },
            },
        },
        // FECHA CANJE
        {
            name: "fechaCanje",
            label: "Fecha de canje",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let fechaCanje = data[dataIndex].fechaCanje;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {fechaCanje === null ? "N/A" : fechaCanje}
                        </div>
                    );
                },
            },
        },
        // FECHA GENERACION
        {
            name: "fechaGeneracion",
            label: "Fecha generación",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let fechaGeneracion =
                        data[dataIndex].fechaGeneracion;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {fechaGeneracion === null ? "N/A" : fechaGeneracion}
                        </div>
                    );
                },
            },
        },
        // FECHA DE PAGO
        {
            name: "fechaPago",
            label: "Fecha de pago",
            options: {
                // display: false,
                download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let fechaPago = data[dataIndex].fechaPago;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {fechaPago === null ? "N/A" : fechaPago}
                        </div>
                    );
                },
            },
        },
        // FECHA DE VENCIMIENTO
        {
            name: "fechaVencimiento",
            label: "Fecha de vencimiento",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let fechaVencimiento =
                        data[dataIndex].fechaVencimiento;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {fechaVencimiento === null ? "N/A" : fechaVencimiento}
                        </div>
                    );
                },
            },
        },
        // ID
        {
            name: "id",
            label: "ID",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let id = data[dataIndex].id;
                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {id === null ? "N/A" : id}
                        </div>
                    );
                },
            },
        },
        // NOMBRE DEPENDENCIA
        {
            name: "nombreDependencia",
            label: "Nombre dependencia",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let nombreDependencia =
                        data[dataIndex].nombreDependencia;
                    return (
                        <div
                            clas
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {nombreDependencia === null ? "N/A" : nombreDependencia}
                        </div>
                    );
                },
            },
        },
        // USUARIO CAPTURA
        {
            name: "usuarioCaptura",
            label: "Usuario captura",
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let usuarioCaptura = data[dataIndex].usuarioCaptura;

                    return (
                        <div
                            style={{
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {usuarioCaptura === null ? "N/A" : usuarioCaptura}
                        </div>
                    );
                },
            },
        },
        {
            name: "reciboSap",
            label: "No Recibo",
            width: 180,
            options: {
                // display: false,
                // download: true,
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let usuarioCaptura = data[dataIndex].reciboSap;

                    return (
                        <div
                            style={{
                                width: 130,
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {usuarioCaptura === null ? "N/A" : usuarioCaptura.substring(1)}
                        </div>
                    );
                },
            },
        },
        {
            name: "estado_deposito",
            label: "Medio de cobro",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, i) => {
                    let estado_dp = data[dataIndex].estado_deposito;

                    return (
                        <div
                            style={{
                                width: 130,
                                height: "100px",
                                overflowX: "hidden",
                                borderRight: "1px solid rgb(172 172 172)",
                            }}
                            className={`px-2 ${i % 2 === 0
                                ? "bg-grisClaro d-flex align-items-center justify-content-center"
                                : "d-flex align-items-center justify-content-center"
                                }`}
                        >
                            {estado_dp === null ? "N/A" : estado_dp}
                        </div>
                    );
                },
            },
        },
        {
            name: "Vermasinfo",
            label: "Ver más",

            options: {
                filter: false,
                sort: false,
                download: false,
                customBodyRenderLite: (dataIndex, i) => {
                    // let op = datafake[dataIndex].broma;
                    return (
                        <>
                            <div
                                style={{ height: "100px" }}
                                className={
                                    i % 2 === 0
                                        ? "w-100 d-flex justify-content-center p-3 bg-grisClaro"
                                        : "w-100 d-flex justify-content-center p-3"
                                }
                            >
                                <div
                                    style={{ height: 40, width: 30, zIndex: 0, marginLeft: 5 }}
                                    className="cta cta--guindagob  cta--icon icon_btn"
                                    onClick={() => {
                                        openModal(data[dataIndex]);
                                    }}
                                >
                                    <IconUI size={"12px"} color={"white"}>
                                        <InfoIcon sx={{ fontSize: "1rem", stroke: "#993367" }} />
                                    </IconUI>
                                </div>
                            </div>
                        </>
                    );
                },
            },
        },
    ];

    const handleSearchChange = (value) => {
        setSearch(value);
    };

    const handleClearSearch = () => {
        setSearch("");
        getBitacora("").then();
    };

    return (
        <>
            {isLoading ? <GifLoader /> : null}
            <div className="container">
                <Box sx={{ height: "auto", paddingTop: "3%" }}>
                    <Box>
                        <div className="my-3">
                            <div className="border-bottom--guinda text-big mb-2 text-bold">
                                Bitácora de movimientos
                            </div>
                        </div>
                        <p
                            style={{
                                color: colorletras,
                                marginLeft: "1%",
                                marginBottom: "1rem",
                            }}
                        >
                            <HomeIcon sx={{ fontSize: "1rem", marginBottom: "2px" }} />
                            inicio/Pagos diversos/Bitácora
                        </p>

                        <div
                            style={{ columnGap: 15, rowGap: 20 }}
                            className="d-flex flex-wrap flex-row justify-content-center m-2 "
                        >
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                onChange={handleFiltros}
                                value={filtros.fechaI}
                                name="fechaI"
                                label="Fecha Inicio"
                                size="small"
                                type="date"
                            />
                            <TextField
                                InputLabelProps={{ shrink: true }}
                                onChange={handleFiltros}
                                value={filtros.fechaF}
                                name="fechaF"
                                label="Fecha Fin"
                                size="small"
                                type="date"
                            />
                            <Button
                                sx={{
                                    backgroundColor: "#6f1d46",
                                }}
                                variant="contained"
                                onClick={() => getBitacora()}
                            >
                                Filtrar
                            </Button>
                        </div>
                        <div
                            style={{ columnGap: 15, rowGap: 20, paddingTop: 10, position: "relative" }}
                            className="d-flex flex-row align-items-center m-2"
                        >
                            <div style={{ flex: 1 }} />

                            <div
                                style={{ maxWidth: 600, flex: "0 auto", columnGap: 10 }}
                                className="d-flex flex-row align-items-center"
                            >
                                <SearchBar
                                    value={search}
                                    onChange={handleSearchChange}
                                    onClear={() => handleClearSearch()}
                                    placeholder="Escribe para filtrar..."
                                />

                                <Button
                                    sx={{ backgroundColor: "#6f1d46", whiteSpace: "nowrap" }}
                                    variant="contained"
                                    onClick={() => getBitacora()}
                                >
                                    Buscar
                                </Button>
                            </div>

                            <div style={{ flex: 1 }} className="d-flex justify-content-end">
                                <Button
                                    sx={{ backgroundColor: "#6f1d46" }}
                                    variant="contained"
                                    onClick={() => getBitacora("", true)}
                                >
                                    Descargar CSV
                                </Button>
                            </div>
                        </div>
                    </Box>
                </Box>
            </div>

            <Grid item className="px-5 pt-4">
                <MUIDataTable
                    style={{ overflow: "hidden" }}
                    title={"Bitácora"}
                    data={data}
                    columns={columns}
                    options={options}
                />
                <Grid container justifyContent="center" sx={{ mt: 3, mb: 5 }}>
                    <Stack direction="row" spacing={5}>
                        <Button 
                            disabled={!meta?.prev_cursor} 
                            variant="contained" 
                            disableElevation 
                            sx={{ backgroundColor: "#6f1d46" }}
                            onClick={()=>getBitacora("",false,meta?.prev_cursor)}
                        >
                            Anterior
                        </Button>
                        <Button 
                            disabled={!meta?.next_cursor} 
                            variant="contained" 
                            disableElevation 
                            sx={{ backgroundColor: "#6f1d46" }}
                            onClick={()=>getBitacora("",false,meta?.next_cursor)}
                        >
                            Siguiente
                        </Button>
                    </Stack>
                </Grid>
            </Grid>

            {state.showmodal ? (
                <>
                    <Modal
                        open={state.showmodal}
                        onClose={closeModal}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={styleModal}>
                            <div
                                style={{
                                    height: 30,
                                    width: 30,
                                    zIndex: 0,
                                    marginLeft: 5,
                                    position: "absolute",
                                    top: "2%",
                                    left: "94%",
                                }}
                                className="cta cta--guindagob  cta--icon icon_btn"
                                onClick={() => {
                                    closeModal();
                                }}
                            >
                                <div>
                                    <IconUI size={"12px"} color={"white"}>
                                        <CancelIcon sx={{ fontSize: "1rem", stroke: "#993367" }} />
                                    </IconUI>
                                </div>
                            </div>
                            <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                sx={{
                                    color: colorletras,
                                    fontWeight: "bold",
                                    fontSize: "1.8rem",
                                }}
                            >
                                Detalle de Línea de captura
                            </Typography>
                            <div className="d-flex">
                                <div>
                                    <div>
                                        <div></div>
                                    </div>
                                </div>
                                <div></div>
                            </div>
                            <Grid
                                container
                                spacing={2}
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    paddingTop: "3%",
                                    marginLeft: "-1%",
                                }}
                            >
                                <Grid item xs={6}>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={3}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <AssignmentTurnedInIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Estatus:
                                            </p>
                                        </Grid>
                                        <Grid item xs={3} sx={{ color: colorletras }}>
                                            {stateModal.EstatusModal}
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={4}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <AttachMoneyIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Importe:
                                            </p>
                                        </Grid>
                                        <Grid
                                            className="ps-0"
                                            item
                                            xs={4}
                                            sx={{ color: colorletras }}
                                        >
                                            ${stateModal.importModal}
                                        </Grid>
                                    </Grid>
                                    {/* <Grid container spacing={2} sx={{ justifyContent: 'left', alignItems: 'left', paddingTop: "1%" }}>
                                    <Grid item xs={6}>
                                        <p style={{ marginLeft: '2%', marginBottom: '0rem' }}><HourglassEmptyIcon sx={{ fontSize: '1rem', marginBottom: '2px', color: colorletras, marginRight: '10px' }} />Periodo</p>
                                    </Grid>
                                    <Grid item xs={3} sx={{ color: colorletras }}>
                                        {stateModal.PeriodoModal}
                                    </Grid>
                                </Grid> */}
                                    {/* <Grid container spacing={2} sx={{ justifyContent: 'left', alignItems: 'left', paddingTop: "1%" }}>
                                    <Grid item xs={6}>
                                        <p style={{ marginLeft: '2%', marginBottom: '0rem' }}><BadgeIcon sx={{ fontSize: '1rem', marginBottom: '2px', color: colorletras, marginRight: '10px' }} />CURP</p>

                                    </Grid>
                                    <Grid item xs={3} sx={{ color: colorletras }}>
                                        {stateModal.CurpModal}
                                    </Grid>
                                </Grid> */}
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={6}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <LocalAtmIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Línea de Captura:
                                            </p>
                                        </Grid>
                                        <Grid
                                            className="ps-0"
                                            item
                                            xs={3}
                                            sx={{ color: colorletras }}
                                        >
                                            {stateModal.LineaCapturaModal}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={6}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <KeyIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Clave dependencia:
                                            </p>
                                        </Grid>
                                        <Grid
                                            className="ps-0"
                                            item
                                            xs={3}
                                            sx={{ color: colorletras }}
                                        >
                                            {stateModal.claveDependencia}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={6}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <PasswordIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Clave oficina:
                                            </p>
                                        </Grid>
                                        <Grid
                                            className="ps-0"
                                            item
                                            xs={3}
                                            sx={{ color: colorletras }}
                                        >
                                            {stateModal.claveOficina}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={6}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <LockIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                ID:
                                            </p>
                                        </Grid>
                                        <Grid
                                            className="ps-0"
                                            item
                                            xs={3}
                                            sx={{ color: colorletras }}
                                        >
                                            {stateModal.idLinea}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={5}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <VerifiedUserIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Usuario captura:
                                            </p>
                                        </Grid>
                                        <Grid item xs={5} sx={{ color: colorletras }}>
                                            {stateModal.usuarioCaptura}
                                        </Grid>
                                    </Grid>
                                    {stateModal.formato ? (
                                        <div className="mt-4">
                                            <button
                                                className="border-0 p-2 bg-guinda bg-vino text-white border rounded-3 d-flex align-items-center gap-1"
                                                onClick={() => {
                                                    window.open(stateModal.formato, "_blank", 'noopener');
                                                }}        
                                            >
                                                Descargar
                                                <LaunchIcon className="size-icons" />
                                            </button>
                                        </div>
                                    ) : null}
                                </Grid>

                                <Grid item xs={6}>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={6}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <EventBusyIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Fecha de Vencimiento:
                                            </p>
                                        </Grid>
                                        <Grid item xs={3} sx={{ color: colorletras }}>
                                            {stateModal.FvencimientoModal}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={7}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <EventIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Fecha de Pago:
                                            </p>
                                        </Grid>
                                        <Grid item xs={3} sx={{ color: colorletras }}>
                                            {stateModal.FpagoModal}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={7}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <CalendarMonthIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Fecha de Canje:
                                            </p>
                                        </Grid>
                                        <Grid item xs={3} sx={{ color: colorletras }}>
                                            {stateModal.FcanjeModal}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={7}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <PersonIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Usuario canje:
                                            </p>
                                        </Grid>
                                        <Grid item xs={3} sx={{ color: colorletras }}>
                                            {stateModal.usuarioCanje}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={7}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <CategoryIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Categoría:
                                            </p>
                                        </Grid>
                                        <Grid item xs={3} sx={{ color: colorletras }}>
                                            {stateModal.categoria}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={7}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <NoteAltIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Fecha generación:
                                            </p>
                                        </Grid>
                                        <Grid item xs={3} sx={{ color: colorletras }}>
                                            {stateModal.fechaGeneracion}
                                        </Grid>
                                    </Grid>
                                    <Grid
                                        container
                                        spacing={2}
                                        sx={{
                                            justifyContent: "left",
                                            alignItems: "left",
                                            paddingTop: "1%",
                                        }}
                                    >
                                        <Grid item xs={7}>
                                            <p
                                                className="fw-bold"
                                                style={{ marginLeft: "2%", marginBottom: "0rem" }}
                                            >
                                                <AccountBalanceIcon
                                                    sx={{
                                                        fontSize: "1rem",
                                                        marginBottom: "2px",
                                                        color: colorletras,
                                                        marginRight: "10px",
                                                    }}
                                                />
                                                Nombre dependencia:
                                            </p>
                                        </Grid>
                                        <Grid item xs={3} sx={{ color: colorletras }}>
                                            {stateModal.nombreDependencia}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <p
                                className="fw-bold"
                                style={{
                                    marginLeft: "2%",
                                    marginTop: "3%",
                                    marginBottom: "0rem",
                                }}
                            >
                                <MessageIcon
                                    sx={{
                                        fontSize: "1rem",
                                        marginBottom: "2px",
                                        color: colorletras,
                                        marginRight: "10px",
                                    }}
                                />
                                Concepto:
                            </p>
                            <p
                                style={{
                                    color: colorletras,
                                    marginTop: "3%",
                                    marginLeft: "2%",
                                }}
                            >
                                {stateModal.ConceptoModal}
                            </p>
                        </Box>
                    </Modal>
                </>
            ) : (
                <></>
            )}
        </>
    );
};

export default Bitacora;
